import {TrackableEntity} from './../fms.core/data/ChangeTrackable';
import { AmsUserPort } from './../fms.data/models/AmsUserPort';

export class AmsUser extends TrackableEntity {
    id: number = 0;
    amsGroupID: number = 0;
    amsGroupName: string = '';
    password: string = '';
    name: string = '';
    email: string = '';
    active: boolean = false;
    userID: string = '';
    seq: number = 0;
    amsSubGroup: string = '';
    fsCompanyID: number = 0;
    pageRowCnt: number = 0;
    companyName: string = '';
    portList: AmsUserPort[] = [];
    carrierList: AmsUserPort[] = [];

    constructor(init?:Partial<AmsUser>) {
        super();
        this.key='id';
        Object.assign(this, init);
        if(this.id === 0) this.id = this.GetNextId();

        if(this.portList.length > 0) {
            this.portList = this.portList.map(d => new AmsUserPort(d));
        } else {
            this.portList = [];
        }
        if(this.carrierList.length > 0) {
            this.carrierList = this.carrierList.map(d => new AmsUserPort(d));
        } else {
            this.carrierList = [];
        }
    }
}
